import { render, staticRenderFns } from "./CustomerOrdersDelete.vue?vue&type=template&id=7ce49c47&scoped=true"
import script from "./CustomerOrdersDelete.vue?vue&type=script&lang=js"
export * from "./CustomerOrdersDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce49c47",
  null
  
)

export default component.exports